"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function LegendsRadioGroup(props) {
    var children = props.children, ariaLabel = props.ariaLabel, value = props.value, onChange = props.onChange;
    return (react_1.default.createElement(Container, null, children.map(function (child) {
        var key = child.key;
        var disabled = child.props.disabled;
        return (react_1.default.createElement(Option, { key: key, onClick: function () {
                !disabled && onChange(key.split('-')[1]);
            }, "$disabled": child.props.disabled },
            react_1.default.createElement(Circle, { "$checked": key === "".concat(ariaLabel, "-").concat(value) }),
            child));
    })));
}
var Option = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 5px;\n  border: 1px solid;\n  border-color: #e3e3e3;\n  border-radius: 5px;\n  cursor: pointer;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  gap: 5px;\n  border: 1px solid;\n  border-color: #e3e3e3;\n  border-radius: 5px;\n  cursor: pointer;\n  align-items: center;\n\n  ", "\n"])), function (p) {
    return p.$disabled &&
        "\n    cursor: not-allowed;\n    opacity: 0.4;\n  ";
});
var Circle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  margin: 0 10px;\n  border: 6px solid;\n  border-color: #818181;\n  border-radius: 50%;\n\n  ", "\n"], ["\n  width: 20px;\n  height: 20px;\n  margin: 0 10px;\n  border: 6px solid;\n  border-color: #818181;\n  border-radius: 50%;\n\n  ", "\n"])), function (p) {
    return !p.$checked &&
        "\n    background-color: #ebecec;  \n    border: none;\n  ";
});
var Container = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 40px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 40px;\n"])));
exports.default = LegendsRadioGroup;
var templateObject_1, templateObject_2, templateObject_3;
